import { render, staticRenderFns } from "./ClassesDetailInfo.vue?vue&type=template&id=08172426&scoped=true&"
import script from "./ClassesDetailInfo.vue?vue&type=script&lang=js&"
export * from "./ClassesDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDetailInfo.vue?vue&type=style&index=0&id=08172426&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08172426",
  null
  
)

export default component.exports